import { jsx as _jsx } from "react/jsx-runtime";
import { SettingCard } from 'console/device-settings/z3k/components/material-utils/settings-card/card';
import { IconsLibrary } from 'console/shared/components/fields/icon';
import { memo, useCallback, useMemo } from 'react';
import { heating_circuits_icons } from 'console/shared/components/fields/icon/icons';
export const CircuitIcon = memo(function CircuitIcon(props) {
    const { onChangeTabState, state } = props;
    const { icon } = state;
    const circuit_id = useMemo(() => state.circuit.id, [state.circuit.id]);
    const onChangeIcon = useCallback((icon) => {
        if (typeof icon === 'number' || typeof icon === 'string') {
            onChangeTabState({ icon });
        }
    }, [onChangeTabState, icon, circuit_id]);
    return (_jsx(SettingCard, { title: "\u0412\u044B\u0431\u043E\u0440 \u0438\u043A\u043E\u043D\u043A\u0438 \u043A\u043E\u043D\u0442\u0443\u0440\u0430", children: _jsx(IconsLibrary, { icons: heating_circuits_icons, onChange: onChangeIcon, value: icon }) }));
});
